import React, { useEffect, useRef, useState } from 'react';
import CardMedia from '@material-ui/core/CardMedia';
import PropTypes from 'prop-types';

const LazyCardMedia = ({ image, component = 'div', ...props }) => {
  const mediaRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const node = mediaRef.current;

    if (!image || !node) return undefined;

    if (typeof window.IntersectionObserver !== 'function') {
      setShouldLoad(true);
      return undefined;
    }

    const observer = new window.IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '300px 0px',
        threshold: 0.01,
      }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [image]);

  return (
    <CardMedia
      {...props}
      component={component}
      ref={mediaRef}
      image={shouldLoad ? image : undefined}
    />
  );
};

LazyCardMedia.propTypes = {
  component: PropTypes.elementType,
  image: PropTypes.string,
};

export default LazyCardMedia;
